import { combineReducers } from "redux";
import queryStringReducer from "./queryStrings/queryStringsReducer";
import cncVoucherReducer from "./cncVoucher/cncVoucherReducer";
import cncWebOrderReducer from "./cncWebOrder/cncWebOrderReducer";
import giftBalanceReducer from "./giftBalance/giftBalanceReducer";
import trackOrderReducer from "./trackOrder/trackOrderReducer";
import loadingIndicatorReducer from "./loadingIndicator/loadingIndicatorReducer";
import assertsReducer from "./assets/assetsReducer";
import uiConfigReducer from "./uiConfig/uiConfigReducer";
import loginReducer from "./login/loginReducer";

const rootReducer = combineReducers({
  uiConfig: uiConfigReducer,
  assets: assertsReducer,
  queryStrings: queryStringReducer,
  cncVoucher: cncVoucherReducer,
  cncWebOrder: cncWebOrderReducer,
  giftBalance: giftBalanceReducer,
  login: loginReducer,
  trackOrder: trackOrderReducer,
  loadingIndicator: loadingIndicatorReducer,
});

export default rootReducer;
